<template>
  <a
    v-if="type === 'external'"
    :aria-label="aria"
    :href="path"
    :tabindex="tabindex"
    target="_blank"
    class="btn"
    :class="[`text-${textcolor}`]"
  >
    <span
      v-if="text"
      :class="[`text-${textsize}`, { 'order-2': iconleft }]"
      v-html="text"
    />
    <IconBase
      v-if="icon"
      :icon="icon"
      :color="iconcolor"
      :size="iconsize"
      :rotate="iconrotation"
      :class="{ 'order-1 mr-2': iconleft, 'ml-2': iconright }"
    />
  </a>

  <button
    v-else-if="type === 'button'"
    :aria-label="aria"
    :disabled="disabled"
    :tabindex="tabindex"
    class="btn"
    :class="[`text-${textcolor}`]"
    @click="$emit('buttonClick')"
  >
    <span
      v-if="text"
      :class="[`text-${textsize}`, { 'order-2': iconleft }]"
      v-html="text"
    />
    <IconBase
      v-if="icon"
      :icon="icon"
      :color="iconcolor"
      :size="iconsize"
      :rotate="iconrotation"
      :class="{ 'order-1 mr-2': iconleft, 'ml-2': iconright }"
    />
  </button>

  <RouterLink
    v-else
    :to="path"
    :aria-label="aria"
    :append="append"
    :tabindex="tabindex"
    class="btn"
    :class="[`text-${textcolor}`]"
  >
    <span
      v-if="text"
      :class="[`text-${textsize}`, { 'order-2': iconleft }]"
      v-html="text"
    />
    <IconBase
      v-if="icon"
      :icon="icon"
      :color="iconcolor"
      :size="iconsize"
      :rotate="iconrotation"
      :class="{ 'order-1 mr-2': iconleft, 'ml-2': iconright }"
    />
  </RouterLink>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import IconBase from '@/components/icons/IconBase.vue'

export default {
  name: 'Button',

  components: {
    IconBase
  },

  props: {
    type: {
      type: String,
      default: ''
    },
    path: {
      type: [Object, String],
      default: '/'
    },
    append: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    iconsize: {
      type: String,
      default: '1.5rem'
    },
    iconcolor: {
      type: String,
      default: 'inherit'
    },
    iconleft: {
      type: Boolean,
      default: false
    },
    iconright: {
      type: Boolean,
      default: false
    },
    iconrotation: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    textsize: {
      type: String,
      default: 'base'
    },
    textcolor: {
      type: String,
      default: 'inherit'
    },
    aria: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: Number,
      default: 0
    }
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters([])
  }
}
</script>
